// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"178":"notfound","353":"contact","594":"about","962":"home"}[chunkId] + "." + {"178":"d0dc1e11","353":"7f293374","594":"dc66a06c","962":"8ce2f385"}[chunkId] + ".js";
};